export var RefreshStatus;

(function (RefreshStatus) {
  RefreshStatus["INITIALISED"] = "INITIALISED";
  RefreshStatus["SUCCESS"] = "SUCCESS";
  RefreshStatus["ERROR"] = "ERROR";
})(RefreshStatus || (RefreshStatus = {}));

export var FeatureFlagServiceApiVersion;

(function (FeatureFlagServiceApiVersion) {
  FeatureFlagServiceApiVersion["V1"] = "v1";
  FeatureFlagServiceApiVersion["V2"] = "v2";
})(FeatureFlagServiceApiVersion || (FeatureFlagServiceApiVersion = {}));